import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        tracking: 'The Journey',
        history: 'Yacht History',
        team: 'Team',
        // sponsors: 'Sponsors',
        // tourists: 'Join Adventure',
        voyage: 'Voyage',
        yacht: 'Yacht',
        contact: 'Contact'
      },
      hero: {
        title: 'Amel Arctic',
        subtitle: 'World Circumnavigation',
        description: 'Follow the incredible journey of our Amel sailing yacht as she circumnavigates the globe, starting with the famous ARC rally.',
        followJourney: 'Follow the Journey'
      },
      stages: {
        title: 'Voyage Stages',
        stage1: {
          title: 'ARC - Atlantic Rally for Cruisers',
          description: 'The legendary transatlantic crossing from Las Palmas de Gran Canaria to the Caribbean. Since 1986, over 200 boats participate annually in this 2,700 nautical mile adventure.',
          route: 'Cabo Roig, Spain → Gran Canaria → Caribbean',
          duration: '18-21 days at sea',
          distance: '2,700 nautical miles'
        },
        stage2: {
          title: 'Pacific Crossing',
          description: 'Navigate through the Panama Canal and sail up the Pacific coast to Seattle, exploring the diverse coastlines of Central and North America.',
          route: 'Caribbean → Panama Canal → Seattle',
          duration: '6-8 weeks',
          distance: '4,500 nautical miles'
        },
        stage3: {
          title: 'Northwest Passage',
          description: 'The challenging Arctic route through northern Canada to Greenland, one of the most remote and beautiful sailing adventures on Earth.',
          route: 'Seattle → Northern Canada → Greenland',
          duration: '3-4 months',
          distance: '3,200 nautical miles'
        },
        stage4: {
          title: 'North Atlantic Return',
          description: 'The final leg home across the North Atlantic from Greenland back to Spain, completing our epic world circumnavigation.',
          route: 'Greenland → Spain',
          duration: '3-4 weeks',
          distance: '2,800 nautical miles'
        },
        stage5: {
          title: 'Stage 5',
          description: 'Description coming soon.',
          route: 'Route TBD',
          duration: 'Duration TBD',
          distance: 'Distance TBD'
        },
        stage6: {
          title: 'Stage 6',
          description: 'Description coming soon.',
          route: 'Route TBD',
          duration: 'Duration TBD',
          distance: 'Distance TBD'
        }
      },
      yacht: {
        title: 'About Amel Arctic',
        description: 'Our vessel is a state-of-the-art Amel sailing yacht, designed for long-distance cruising and built to handle the challenges of world circumnavigation.',
        specifications: 'Specifications',
        length: 'Length',
        beam: 'Beam',
        draft: 'Draft',
        displacement: 'Displacement'
      },
      map: {
        title: 'Live Tracking',
        currentPosition: 'Current Position',
        nextDestination: 'Next Destination',
        progress: 'Progress'
      },
      // Modal translations
      contact_us: 'Contact Us',
      apply_position: 'Apply for Position',
      become_partner: 'Become a Partner',
      book_adventure: 'Book Adventure',
      contact_subtitle: 'Get in touch with our team for any questions about the Arctic Owl expedition.',
      apply_subtitle: 'Join our crew and be part of this incredible world circumnavigation adventure.',
      partner_subtitle: 'Partner with us and support this amazing journey around the world.',
      book_subtitle: 'Reserve your spot on one of our expedition segments and experience the adventure of a lifetime.',
      full_name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      enter_name: 'Enter your full name',
      enter_email: 'Enter your email address',
      enter_phone: 'Enter your phone number',
      enter_message: 'Tell us about your interest...',
      desired_position: 'Desired Position',
      sailing_experience: 'Sailing Experience',
      tour_package: 'Tour Package',
      select_position: 'Select a position',
      select_package: 'Select a package',
      describe_experience: 'Describe your sailing and maritime experience...',
      captain: 'Captain',
      first_mate: 'First Mate',
      navigator: 'Navigator',
      engineer: 'Engineer',
      cook: 'Cook',
      deckhand: 'Deckhand',
      arc_rally_experience: 'ARC Rally Experience',
      pacific_adventure: 'Pacific Adventure',
      arctic_expedition: 'Arctic Expedition',
      full_circumnavigation: 'Full Circumnavigation',
      send_message: 'Send Message',
      sending: 'Sending...',
      message_sent: 'Message Sent Successfully!',
      message_sent_description: 'Thank you for your interest. We will get back to you within 24 hours.',
      // Home page
      home: {
        title: 'Arctic Owl',
        subtitle: 'North-Western Arctic passage Expedition',
        description: 'Join the incredible journey of Arctic Owl sailing yacht as she circumnavigates The North America, starting with the famous ARC rally through the legendary Northwest Passage to complete one of sailing\'s greatest adventures.',
        track_live_journey: 'Track Live Journey',
        join_adventure: 'Join the Adventure',
        nautical_miles: 'Nautical Miles',
        continents: 'Continents',
        months: 'Months',
        meet_arctic_owl: 'Meet Arctic Owl - Amel Arctic 55',
        technical_specifications: 'Technical Specifications',
        arctic_ready_features: 'Arctic-Ready Features',
        epic_journey_ahead: 'Epic Journey Ahead',
        yacht_video_tour: 'Yacht Video Tour'
      },
      // Tourists page
      // tourists: {
      //   title: 'Join the Adventure',
      //   subtitle: 'Experience the ultimate sailing adventure aboard Arctic Owl. Choose from various expedition segments or join us for the complete world circumnavigation.',
      //   tour_packages: 'Tour Packages',
      //   accommodations: 'Accommodations',
      //   yacht_gallery: 'Yacht Gallery',
      //   book_this_adventure: 'Book This Adventure',
      //   ready_for_adventure: 'Ready for the Adventure of a Lifetime?',
      //   expert_crew: 'Expert Crew',
      //   safety_first: 'Safety First',
      //   gourmet_dining: 'Gourmet Dining',
      //   memories: 'Memories',
      //   download_brochure: 'Download Brochure'
      // },
      // Team page
      team: {
        title: 'Expedition Team',
        subtitle: 'Meet the dedicated crew of Arctic Owl and discover opportunities to join our world circumnavigation adventure.',
        current_crew: 'Current Crew',
        open_positions: 'Open Positions',
        apply_now: 'Apply Now',
        contact_us: 'Contact Us'
      },
      // History page
      history: {
        title: 'Arctic Owl Construction History',
        subtitle: 'The story behind the construction of our magnificent Arctic Owl sailing yacht, built for the ultimate world circumnavigation adventure.',
        final_specifications: 'Final Specifications'
      },
      // Sponsors page
      // sponsors: {
      //   title: 'Expedition Sponsors',
      //   subtitle: 'Partner with Arctic Owl\'s historic world circumnavigation and reach a global audience passionate about sailing, adventure, and maritime exploration.',
      //   sponsorship_packages: 'Sponsorship Packages',
      //   current_sponsors: 'Current Partners',
      //   become_sponsor: 'Become a Sponsor'
      // }
    }
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        tracking: 'Seguimiento en Vivo',
        history: 'Historia del Yate',
        team: 'Equipo',
        sponsors: 'Patrocinadores',
        tourists: 'Únete a la Aventura',
        voyage: 'Viaje',
        yacht: 'Yate',
        contact: 'Contacto'
      },
      hero: {
        title: 'Amel Arctic',
        subtitle: 'Vuelta al Mundo',
        description: 'Sigue el increíble viaje de nuestro velero Amel mientras circunnavega el globo, comenzando con la famosa regata ARC.',
        followJourney: 'Seguir el Viaje'
      },
      stages: {
        title: 'Etapas del Viaje',
        stage1: {
          title: 'ARC - Atlantic Rally for Cruisers',
          description: 'La legendaria travesía transatlántica desde Las Palmas de Gran Canaria hasta el Caribe. Desde 1986, más de 200 barcos participan anualmente en esta aventura de 2,700 millas náuticas.',
          route: 'Cabo Roig, España → Gran Canaria → Caribe',
          duration: '18-21 días en el mar',
          distance: '2,700 millas náuticas'
        },
        stage2: {
          title: 'Cruce del Pacífico',
          description: 'Navegar a través del Canal de Panamá y navegar por la costa del Pacífico hasta Seattle, explorando las diversas costas de América Central y del Norte.',
          route: 'Caribe → Canal de Panamá → Seattle',
          duration: '6-8 semanas',
          distance: '4,500 millas náuticas'
        },
        stage3: {
          title: 'Paso del Noroeste',
          description: 'La desafiante ruta ártica a través del norte de Canadá hasta Groenlandia, una de las aventuras de navegación más remotas y hermosas de la Tierra.',
          route: 'Seattle → Norte de Canadá → Groenlandia',
          duration: '3-4 meses',
          distance: '3,200 millas náuticas'
        },
        stage4: {
          title: 'Regreso por el Atlántico Norte',
          description: 'La etapa final a casa a través del Atlántico Norte desde Groenlandia de vuelta a España, completando nuestra épica circunnavegación mundial.',
          route: 'Groenlandia → España',
          duration: '3-4 semanas',
          distance: '2,800 millas náuticas'
        },
        stage5: {
          title: 'Etapa 5',
          description: 'Descripción próximamente.',
          route: 'Ruta por definir',
          duration: 'Duración por definir',
          distance: 'Distancia por definir'
        },
        stage6: {
          title: 'Etapa 6',
          description: 'Descripción próximamente.',
          route: 'Ruta por definir',
          duration: 'Duración por definir',
          distance: 'Distancia por definir'
        }
      },
      yacht: {
        title: 'Sobre Amel Arctic',
        description: 'Nuestro barco es un velero Amel de última generación, diseñado para cruceros de larga distancia y construido para manejar los desafíos de la circunnavegación mundial.',
        specifications: 'Especificaciones',
        length: 'Eslora',
        beam: 'Manga',
        draft: 'Calado',
        displacement: 'Desplazamiento'
      },
      map: {
        title: 'Seguimiento en Vivo',
        currentPosition: 'Posición Actual',
        nextDestination: 'Próximo Destino',
        progress: 'Progreso'
      },
      // Modal translations
      contact_us: 'Contáctanos',
      apply_position: 'Solicitar Posición',
      become_partner: 'Convertirse en Socio',
      book_adventure: 'Reservar Aventura',
      contact_subtitle: 'Ponte en contacto con nuestro equipo para cualquier pregunta sobre la expedición Arctic Owl.',
      apply_subtitle: 'Únete a nuestra tripulación y sé parte de esta increíble aventura de circunnavegación mundial.',
      partner_subtitle: 'Asóciate con nosotros y apoya este increíble viaje alrededor del mundo.',
      book_subtitle: 'Reserva tu lugar en uno de nuestros segmentos de expedición y vive la aventura de tu vida.',
      full_name: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      message: 'Mensaje',
      enter_name: 'Ingresa tu nombre completo',
      enter_email: 'Ingresa tu dirección de correo electrónico',
      enter_phone: 'Ingresa tu número de teléfono',
      enter_message: 'Cuéntanos sobre tu interés...',
      desired_position: 'Posición Deseada',
      sailing_experience: 'Experiencia de Navegación',
      tour_package: 'Paquete Turístico',
      select_position: 'Selecciona una posición',
      select_package: 'Selecciona un paquete',
      describe_experience: 'Describe tu experiencia en navegación y marítima...',
      captain: 'Capitán',
      first_mate: 'Primer Oficial',
      navigator: 'Navegante',
      engineer: 'Ingeniero',
      cook: 'Cocinero',
      deckhand: 'Marinero',
      arc_rally_experience: 'Experiencia ARC Rally',
      pacific_adventure: 'Aventura del Pacífico',
      arctic_expedition: 'Expedición Ártica',
      full_circumnavigation: 'Circunnavegación Completa',
      send_message: 'Enviar Mensaje',
      sending: 'Enviando...',
      message_sent: '¡Mensaje Enviado Exitosamente!',
      message_sent_description: 'Gracias por tu interés. Te responderemos dentro de 24 horas.',
      // Home page
      home: {
        title: 'Arctic Owl',
        subtitle: 'Expedición de Circunnavegación Mundial',
        description: 'Únete al increíble viaje del velero Arctic Owl mientras circunnavega el globo, comenzando con la famosa regata ARC a través del legendario Paso del Noroeste para completar una de las mayores aventuras de navegación.',
        track_live_journey: 'Seguir Viaje en Vivo',
        join_adventure: 'Únete a la Aventura',
        nautical_miles: 'Millas Náuticas',
        continents: 'Continentes',
        months: 'Meses',
        meet_arctic_owl: 'Conoce Arctic Owl - Amel Arctic 55',
        technical_specifications: 'Especificaciones Técnicas',
        arctic_ready_features: 'Características Árticas',
        epic_journey_ahead: 'Épico Viaje por Delante',
        yacht_video_tour: 'Tour de Video del Yate'
      },
      // Tourists page
      tourists: {
        title: 'Únete a la Aventura',
        subtitle: 'Vive la última aventura de navegación a bordo del Arctic Owl. Elige entre varios segmentos de expedición o únete a nosotros para la circunnavegación mundial completa.',
        tour_packages: 'Paquetes Turísticos',
        accommodations: 'Alojamientos',
        yacht_gallery: 'Galería del Yate',
        book_this_adventure: 'Reservar Esta Aventura',
        ready_for_adventure: '¿Listo para la Aventura de tu Vida?',
        expert_crew: 'Tripulación Experta',
        safety_first: 'Seguridad Primero',
        gourmet_dining: 'Comida Gourmet',
        memories: 'Recuerdos',
        download_brochure: 'Descargar Folleto'
      },
      // Team page
      team: {
        title: 'Equipo de Expedición',
        subtitle: 'Conoce la tripulación dedicada del Arctic Owl y descubre oportunidades para unirte a nuestra aventura de circunnavegación mundial.',
        current_crew: 'Tripulación Actual',
        open_positions: 'Posiciones Abiertas',
        apply_now: 'Aplicar Ahora',
        contact_us: 'Contáctanos'
      },
      // History page
      history: {
        title: 'Historia de Construcción del Arctic Owl',
        subtitle: 'La historia detrás de la construcción de nuestro magnífico velero Arctic Owl, construido para la última aventura de circunnavegación mundial.',
        final_specifications: 'Especificaciones Finales'
      },
      // Sponsors page
      sponsors: {
        title: 'Patrocinadores de la Expedición',
        subtitle: 'Asóciate con la histórica circunnavegación mundial del Arctic Owl y alcanza una audiencia global apasionada por la navegación, la aventura y la exploración marítima.',
        sponsorship_packages: 'Paquetes de Patrocinio',
        current_sponsors: 'Socios Actuales',
        become_sponsor: 'Convertirse en Patrocinador'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 
